import styled from 'styled-components';

// 14-oct (feedback del usuario: «has reinventado en vez de reutilizar las
// tablas»): el modal ancho y la tabla de selección de siempre, como el
// «Transferir» de actuaciones y «Vincular tramo». Sus piezas se reutilizan tal
// cual; aquí no se define ninguna tarjeta propia.
export {
  ButtonContainer,
  CloseButton,
  Container,
  EmptyMessage,
  MainButtonStyled,
  PaginationButtonsStyled,
} from '../RelateSegmentModal/styles';

// El motivo de un destino que no cabe y los avisos (básica que se suelta,
// recorrido que se queda vacío): los mismos que «Corregir».
export {
  InlineError,
  CrossingNotice as Notice,
  CrossingNoticeIcon as NoticeIcon,
  Text,
} from '../EditSegmentModal/styles';

/**
 * 30-oct (el usuario): los avisos que NO bloquean (PK que se pisan, básica que
 * se suelta, recorrido que se queda vacío) van como texto centrado, con el
 * mismo color y tamaño que el motivo de un destino que no cabe, y no en una
 * caja naranja: debajo de la tabla todos los mensajes se leen igual.
 */
export { InlineError as WarningText } from '../EditSegmentModal/styles';

/** Debajo de la tabla: dónde quedará el tramo, el motivo y los avisos. */
export const BelowTable = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spaces.xs}rem;
  margin-top: ${({ theme }) => theme.spaces.m}rem;
`;
